// dependancies
import React from "react";
import PropTypes from "prop-types";

// styles
import FieldPromptStyled from "./FieldPrompt.styled";

const Prompt = ({ message }) => {
    return <FieldPromptStyled>{message}</FieldPromptStyled>;
};

export default Prompt;

// props validation
Prompt.propTypes = {
    message: PropTypes.string.isRequired
};
